<template>
  <v-app>
    <v-app-bar app>

      <v-layout row wrap justify-space-between>

        <Breadcrumb/>
      </v-layout>

    </v-app-bar>
    <v-content>



    <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import Breadcrumb from "./components/Breadcrumb";

export default {
  name: 'App',
  components: {
    Breadcrumb
  },
  data: () => ({
    //
  }),
};
</script>
